import React from 'react';
import { useIssueCardMutation } from 'lib/services';

import LSDStatusCardModal from '../presentational/LSDStatusCardModal';

const LSDStatusCardModalContainer = ({ hideModal }) => {
    const [issueCardMutation] = useIssueCardMutation();

    const handleClose = () => hideModal();

    const handleSubmit = () => {
        issueCardMutation();
        handleClose();
    };

    return (
        <div className="status-card-modal">
            <LSDStatusCardModal
                handleSubmit={handleSubmit}
                handleClose={handleClose}
            />
        </div>
    );
};

export default LSDStatusCardModalContainer;
